var products_on_page = $('.current-product-page');
var next_url = products_on_page.data('next-url');
var load_more_spinner = $('.infinite-scroll');
load_more_spinner.hide();
var loading = false;

function showSpinner() {
  load_more_spinner.show();
  load_more_spinner.addClass('loading');
  load_more_spinner.find('.loading-overlay__spinner').removeClass('hidden');
}

function hideSpinner() {
  load_more_spinner.hide();
  load_more_spinner.removeClass('loading');
  load_more_spinner.find('.loading-overlay__spinner').addClass('hidden');
}

function loadMoreProducts() {
  if (!loading && next_url) {
    loading = true;
    showSpinner();

    $.ajax({
      url: next_url,
      type: 'GET',
      dataType: 'html'
    }).done(function (next_page) {
      var new_products = $(next_page).find('.current-product-page');
      if (new_products.length > 0) {
        var new_url = new_products.data('next-url');
        next_url = new_url;
        var newProductList = products_on_page.clone();
        newProductList.attr('data-next-url', new_url);
        newProductList.html(new_products.html());
        var infiniteScrollElement = $('.infinite-scroll');

        newProductList.insertBefore(infiniteScrollElement);
        if (window.innerWidth < 992) {
          reduceSwatches();
        }
        handleOptionSize();
      } else {
        next_url = null;
        hideSpinner();
      }
      hideSpinner();
      loading = false;
      setTimeout(() => {
        $('.skeleton.skeleton-text').removeClass('skeleton-text skeleton');
        $('.skeleton.skeleton-variant').removeClass(
          'skeleton-variant skeleton'
        );
      }, 1000);
    });
  }
}

$(document).ready(function () {
  $(window).on('scroll', function () {
    var scrollPosition = $(window).scrollTop();
    var productList = $('.my-collection');
    var productListHeight = productList.height();
    var productListTop = productList.offset().top;

    if (
      scrollPosition + $(window).height() >=
      productListTop + productListHeight
    ) {
      loadMoreProducts();
    }
  });
});
